module.exports = __webpack_public_path__ + "static/media/leg1.90d624b9.png";